module.exports = __webpack_public_path__ + "img/LV.60b9d3c3.svg";